var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"36bda0c55da698b70a7e2470859bc8ff998d980e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["prepcenter-frontend@goaura"]={id:"36bda0c55da698b70a7e2470859bc8ff998d980e"};
      